import { styled } from '@mui/material/styles';

export const IconContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.black,
  display: 'flex',
  height: 64,
  justifyContent: 'center',
  width: 56,
  '& svg': {
    fill: theme.palette.text.primary,
  },
}));
